export const RISK_ROUTES = [
  '/contestacoes',
  '/contestacoes/abertura-de-contestacao/descrever-problema',
  '/contestacoes/abertura-de-contestacao/resultado',
  '/contestacoes/abertura-de-contestacao/selecionar-transacoes'
] as const
